import $ from "jquery";
import {BllinkLogger} from "./bllink_loggers";

class JsExtras {

    static getRange(maxInt) {
        // input 10 => will return array [1,2,..10]

        return Array.from({length: maxInt}, (_, i) => i + 1)

    }

    static range(minInt, range) {
        // input 10, 5 => will return array [10,11,12,13,14,15]

        return Array.from({length: range}, (_, i) => i + minInt)

    }

    static getUrlParameter(sParam) {
        let sPageURL = window.location.search.substring(1),
            sURLVariables = sPageURL.split('&'),
            sParameterName,
            i;

        for (i = 0; i < sURLVariables.length; i++) {
            sParameterName = sURLVariables[i].split('=');

            if (sParameterName[0] === sParam) {
                return sParameterName[1] === undefined ? true : decodeURIComponent(sParameterName[1]);
            }
        }
    }

    static sum(array, key){
        return array.reduce((a, b) => a + (parseFloat(this.getValue(b, key)) || 0), 0);
    }

    static getValue(item, key){
        // key examples: 'bla', 'foo.bla'

        const parts = key.split('.');

        let itemFinal = item;
        for (const part of parts){
            itemFinal = itemFinal[part];
            if (!itemFinal){
                return
            }
        }

        return itemFinal
    }

    static validate(obj, keys){
        /*
            created to validate object
            was create to avoid future bugs like this one https://app.asana.com/0/1196545425570329/1198912119756103  [Bug] final page before cc - installments
         */

        const objectKeys = Object.keys(obj);
        let missingKeys = [];
        for (const requiredKey of keys){
            if (!objectKeys.includes(requiredKey) || !obj[requiredKey]){
                missingKeys.push(requiredKey)
            }
        }

        if (missingKeys.length>0){
            throw new Error(`required keys ${JSON.stringify(missingKeys)} are missing from object ${JSON.stringify(obj)}`)
        }
    }

    static validURL(str) {
        let pattern = new RegExp('^(https?:\\/\\/)?'+ // protocol
            '((([a-z\\d]([a-z\\d-]*[a-z\\d])*)\\.)+[a-z]{2,}|'+ // domain name
            '((\\d{1,3}\\.){3}\\d{1,3}))'+ // OR ip (v4) address
            '(\\:\\d+)?(\\/[-a-z\\d%_.~+]*)*'+ // port and path
            '(\\?[;&a-z\\d%_.~+=-]*)?'+ // query string
            '(\\#[-a-z\\d_]*)?$','i'); // fragment locator
        return !!pattern.test(str);
    }

    static isNumeric(str) {
        if (!["string", "number"].includes(typeof str)) return false // we only process strings!
        return !isNaN(str) && // use type coercion to parse the _entirety_ of the string (`parseFloat` alone does not do this)...
            !isNaN(parseFloat(str)) // ...and ensure strings of whitespace fail
    }

    static preventTextInPhoneInput(event){
        /*
            https://app.asana.com/0/1196545425570329/1198875635740805
            don't allow type letter in the phone field
         */
        console.log(`keypress`, event)
        let regex = new RegExp("^[0-9]+$");
        let key = String.fromCharCode(!event.charCode ? event.which : event.charCode);
        if (!regex.test(key)) {
            event.preventDefault();
            return false;
        }
    }

    static phoneValidator(element, elementValue, options){
        console.log(`phone validating`, element);
        let afterRemovingDashes = elementValue.replace(/-/g, '').trim();
        let afterReplacePrefix = afterRemovingDashes.replace(/\+972/g, '0').trim();
        BllinkLogger.info(`afterReplacePrefix`, afterReplacePrefix);

        let len = afterReplacePrefix.length
        // requested to support 9 and 10 by rayee on email on 21/7/21
        let minLength = options.minLength || 10;
        let maxLength = options.maxLength || 10;
        const isValid = (len >= minLength) && (len <= maxLength)
        $('#phone').val(afterReplacePrefix);
        return isValid
    }

    static emailValidator(email){
        if (!email){
            return true
        }
        //    https://stackoverflow.com/a/9082446/13806459
        let emailReg = /^([\w-.]+@([\w-]+\.)+[\w-]{2,4})?$/;
        return emailReg.test( email );
    }
}

export default JsExtras
